import type { IRowNode } from 'ag-grid-community'
import { playerSort } from 'src/utils/sortingUtils'

/** Fields the roster grids sort by — the keys `playerSort` understands. */
export type RosterSortField = 'name_last' | 'player_number' | 'player_type.id'

/**
 * An AG Grid comparator backed by the app's shared `playerSort`, so the roster
 * sorts exactly as it did before (last then first name, numeric jersey, …).
 * Always ascending: AG Grid reverses it for a descending sort.
 */
export const rosterComparator =
  <TRow>(field: RosterSortField) =>
  (
    _valueA: unknown,
    _valueB: unknown,
    nodeA: IRowNode<TRow>,
    nodeB: IRowNode<TRow>
  ): number =>
    playerSort(field, 'asc')(nodeA.data, nodeB.data)

/** Rows pre-sorted by name, the grids' default order. */
export const sortByName = <TRow>(rows: TRow[]): TRow[] =>
  [...rows].sort(playerSort('name_last', 'asc'))
